import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { dataCartSelector, removeItemCartById } from '~/redux/cartSlice'
import styles from '../styles/ordering.module.css'
import { path } from '~/routes/path'
import { useNavigate } from 'react-router-dom'
import { XMarkIcon } from '~/assets/icons'
import ReactHtmlParser from 'react-html-parser'

const PopupDeleteItem = ({ idErrorOrder, showPopupError, setShowPopupError }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { food_item_id, topping_id } = idErrorOrder

  const itemsCart = useSelector(dataCartSelector)

  const getNameDeleted = () => {
    let nameDelete = ''
    itemsCart.forEach((itemCart) => {
      if (topping_id) {
        itemCart.foodOptionTypes.forEach((item) => {
          item.foodOptions.forEach((option) => {
            if (option.id === topping_id) {
              nameDelete = option.name
              return
            }
          })
        })
      } else {
        if (itemCart.id === food_item_id) {
          nameDelete = itemCart.name
        }
      }
    })
    return nameDelete
  }

  const handleConFirmPopup = () => {
    dispatch(removeItemCartById({ food_item_id, topping_id }))
    setShowPopupError(false)
    navigate(path.yourCart)
  }
  const handleCancelPopup = () => {
    setShowPopupError(false)
  }

  const renderIconClosePopup = () => {
    return (
      <Box className={styles.icon_cancel_popup} onClick={handleCancelPopup}>
        <XMarkIcon size="14" />
      </Box>
    )
  }

  const renderTitlePopup = () => {
    const title =
      food_item_id && topping_id
        ? ReactHtmlParser(
            t('titles.popup_topping_error_order', {
              nameTopping: getNameDeleted(),
              fontWeight: 600,
            }),
          )
        : ReactHtmlParser(
            t('titles.popup_food_error_order', {
              nameFood: getNameDeleted(),
              fontWeight: 600,
            }),
          )
    return <Typography>{title}</Typography>
  }

  const renderBtnUpdate = () => {
    return (
      <Button className={styles.btn_confirm_popup} onClick={handleConFirmPopup}>
        {t('actions.update')}
      </Button>
    )
  }

  return (
    <Modal open={showPopupError}>
      <Box className={styles.wrapper_popup_show_error}>
        <Box className={styles.inner_popup_show_error}>
          {renderIconClosePopup()}
          {renderTitlePopup()}
          {renderBtnUpdate()}
        </Box>
      </Box>
    </Modal>
  )
}

PopupDeleteItem.propTypes = {
  idErrorOrder: PropTypes.object,
  showPopupError: PropTypes.bool,
  setShowPopupError: PropTypes.func,
}

export default PopupDeleteItem
